import React, { useContext } from 'react';
import * as PropTypes from 'prop-types';

import { PatientEncounterReviewApi } from '../../../../../../../api';
import ModalBoxes from '../../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import { COMMENTS_DOMAIN_CODE, NEW_TABLE, TABLE } from '../../reviewConstants';
import { ReviewContext } from '../../ReviewContext';
import ElementHistoryLogModal from '../HistoryLogModal/ElementHistoryLogModal';
import ItemGroupElementHeader from '../ItemGroupElementHeader/ItemGroupElementHeader';
import { getItemGroupType } from '../reviewContentService';

import CommentItemGroup from './CommentItemGroup/CommentItemGroup';
import ItemGroupNewTable from './ItemGroupNewTable/ItemGroupNewTable';
import ItemGroupNotPerformed from './ItemGroupNotPerformed/ItemGroupNotPerformed';
import ItemGroupProcedure from './ItemGroupProcedure/ItemGroupProcedure';
import ItemGroupTable from './ItemGroupTable/ItemGroupTable';

import './ItemGroupElement.scss';

export default function ItemGroupElement({ itemGroupSnapshotState }) {
  const { isHistoricalData } = useContext(ReviewContext);

  const patientItemGroupId = itemGroupSnapshotState.itemGroupRef.patientItemGroupId;

  const itemGroupName = itemGroupSnapshotState?.itemGroupRef.patientItemGroupName;
  const itemGroupType = getItemGroupType(itemGroupSnapshotState?.itemGroupRef);
  const domainCode = itemGroupSnapshotState?.itemGroupRef.domainCode;
  const isNotPerformed = itemGroupSnapshotState?.dataStatus.notPerformed;
  const showHistoryButton =
    !isNotPerformed &&
    itemGroupType !== TABLE &&
    itemGroupType !== NEW_TABLE &&
    domainCode !== COMMENTS_DOMAIN_CODE &&
    !isHistoricalData;

  return (
    <div className="eds-review-item-group-element" id={patientItemGroupId}>
      <ItemGroupElementHeader
        itemGroupName={itemGroupName}
        itemGroupType={itemGroupType}
        showHistoryButton={showHistoryButton}
        getAnswersHistory={getAnswersHistory}
      />
      {templateResolver(itemGroupSnapshotState)}
    </div>
  );

  function getAnswersHistory() {
    const ssuPatientId = itemGroupSnapshotState.rows[0].rowSnapshotKey.rowKey.ssuPatientId;
    const ssuPatientEncounterId = itemGroupSnapshotState.itemGroupRef.patientEncounterId;
    const itemGroupId = patientItemGroupId;
    const rowId = itemGroupSnapshotState.rows[0].rowSnapshotFormData.rowId;
    const itemGroupName = itemGroupSnapshotState.itemGroupRef.patientItemGroupName;
    const onLoadData = () =>
      PatientEncounterReviewApi.getItemGroupAnswerHistory(ssuPatientId, ssuPatientEncounterId, itemGroupId, rowId);
    ModalBoxes.open({
      component: <ElementHistoryLogModal itemGroupName={itemGroupName} onLoadData={onLoadData} />,
      title: itemGroupName
    });
  }
}

ItemGroupElement.propTypes = {
  itemGroupSnapshotState: PropTypes.object
};

function templateResolver(itemGroupSnapshotState) {
  const { patientItemGroupType, domainCode } = itemGroupSnapshotState?.itemGroupRef;
  const { notPerformedReason, notPerformed } = itemGroupSnapshotState.dataStatus;

  if (notPerformed) {
    return <ItemGroupNotPerformed notPerformedReason={notPerformedReason} />;
  }

  if (patientItemGroupType === TABLE) {
    return <ItemGroupTable itemGroupSnapshotState={itemGroupSnapshotState} />;
  }

  if (domainCode === COMMENTS_DOMAIN_CODE) {
    return <CommentItemGroup itemGroupSnapshotState={itemGroupSnapshotState} />;
  }

  if (patientItemGroupType === NEW_TABLE) {
    return <ItemGroupNewTable itemGroupSnapshotState={itemGroupSnapshotState} />;
  }

  return <ItemGroupProcedure itemGroupSnapshotState={itemGroupSnapshotState} />;
}
